import * as React from "react";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import { useMediaQuery } from "@mui/material";
import Masonry from "react-masonry-css";
import ImageFadeIn from "../ImageFadeIn";
import "./style.css";

const SimpleMasonry = (props) => {
    const { content } = props;
    const matches = useMediaQuery("(min-width:600px)");
    const handleClick = (e, item) => {
        props.onImageSelection(item);
    };
    const breakpointColumnsObj = {
        default: 3,
        1100: 3,
        700: 2,
        500: 1,
    };
    return (
        // <ImageList sx={{ mt: "0px", marginBottom: "0rem" }} cols={matches ? 3 : 2} gap={1}>
        //     {content?.map((item) => (
        //         <ImageListItem sx={{ px: 0.5 }} key={item.img}>
        //             <img
        //                 srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
        //                 src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
        //                 alt={item.title}
        //                 loading="lazy"
        //                 style={{ borderRadius: "5px" }}
        //                 onClick={(e) => handleClick(e, item)}
        //             />
        //         </ImageListItem>
        //     ))}
        // </ImageList>
        <Masonry
            style={{ marginTop: "0px" }}
            breakpointCols={breakpointColumnsObj}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column">
            {content?.map((item, index) => (
                <ImageFadeIn
                    onClick={(e) => handleClick(e, item)}
                    srcSet={`${item.img}?w=162&auto=format&dpr=2 2x`}
                    src={`${item.img}?w=162&auto=format`}
                    alt={item.title}
                    loading="lazy"
                    style={{
                        display: "block",
                        width: "100%",
                        marginBottom: "8px",
                    }}></ImageFadeIn>
            ))}
        </Masonry>
    );
};

export { SimpleMasonry };
